"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPagination = exports.StyledZoomButton = exports.StyledCloseIcon = exports.StyledModalBody = exports.StyledThumbs = exports.StyledImageSwiper = exports.StyledSwiper = exports.CommonSwiper = exports.StyledImageSlide = void 0;
var _styled = _interopRequireDefault(require("@material-ui/core/styles/styled"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _Slides = require("../smart-swiper/Slides");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var StyledImageSlide = (0, _styled.default)(_Slides.ImageSlide)({
  margin: '0 auto',
  width: '100%',
  height: '100%'
});
exports.StyledImageSlide = StyledImageSlide;
var CommonSwiper = (0, _styled.default)('div')({
  '& .swiper-wrapper': {
    listStyle: 'none',
    paddingInlineStart: 0
  }
});
exports.CommonSwiper = CommonSwiper;
var StyledSwiper = (0, _styled.default)(CommonSwiper)(function (_ref) {
  var _swiperButtonPre, _swiperButtonNex;
  var theme = _ref.theme;
  return {
    height: '100%',
    '& .swiper-slide': {
      display: 'flex',
      justifyContent: 'center',
      overflow: 'hidden'
    },
    '& .swiper-container': {
      height: '100%',
      '& .swiper-wrapper': {
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        height: '100%',
        marginBlockEnd: 0,
        marginBlockStart: 0
      },
      '& .swiper-button-prev': (_swiperButtonPre = {
        backgroundColor: 'rgba(0, 0, 0, 0.35)',
        color: 'white',
        height: '60px',
        left: 0,
        padding: '10px 0',
        width: '40px',
        border: 'none'
      }, _defineProperty(_swiperButtonPre, theme.breakpoints.down('md'), {
        display: 'none'
      }), _defineProperty(_swiperButtonPre, '&::after', {
        display: 'none'
      }), _swiperButtonPre),
      '& .swiper-button-next': (_swiperButtonNex = {
        backgroundColor: 'rgba(0, 0, 0, 0.35)',
        color: 'white',
        height: '60px',
        right: 0,
        padding: '10px 0',
        width: '40px',
        border: 'none'
      }, _defineProperty(_swiperButtonNex, theme.breakpoints.down('md'), {
        display: 'none'
      }), _defineProperty(_swiperButtonNex, '&::after', {
        display: 'none'
      }), _swiperButtonNex),
      '& .swiper-button-disabled': {
        display: 'none'
      }
    },
    '& img': {
      display: 'flex',
      objectFit: 'contain'
    },
    '& .zoom-icon': {
      backgroundColor: 'transparent',
      border: 'none',
      bottom: '20px',
      display: 'block',
      height: '45px',
      objectFit: 'fill',
      position: 'absolute',
      right: '20px',
      transform: 'none',
      transitionDuration: '0s',
      width: '45px',
      zIndex: 1,
      cursor: 'pointer'
    }
  };
});
exports.StyledSwiper = StyledSwiper;
var StyledImageSwiper = (0, _styled.default)(StyledSwiper)(function (_ref2) {
  var theme = _ref2.theme;
  return _defineProperty({
    height: 'calc(100% - 32px)'
  }, theme.breakpoints.up('md'), {
    height: 'calc(100% - 100px)'
  });
});
exports.StyledImageSwiper = StyledImageSwiper;
var StyledThumbs = (0, _styled.default)(CommonSwiper)(function (_ref4) {
  var _ref5;
  var theme = _ref4.theme;
  return _ref5 = {
    display: 'block'
  }, _defineProperty(_ref5, theme.breakpoints.down('md'), {
    display: 'none'
  }), _defineProperty(_ref5, '& .swiper-container-thumbs', {
    marginBottom: '20px',
    '& .swiper-wrapper': {
      justifyContent: 'center'
    }
  }), _defineProperty(_ref5, '& .swiper-wrapper', {
    alignItems: 'center',
    height: '55px',
    margin: '20px 0'
  }), _defineProperty(_ref5, '& .swiper-scrollbar', _defineProperty({
    background: 'linear-gradient(180deg, rgba(255,255,255,1) 45%, rgba(198,198,198,1) 45%, rgba(198,198,198,1) 50%, rgba(198,198,198,1) 55%, rgba(255,255,255,1) 55%)'
  }, theme.breakpoints.up('md'), {
    display: 'none'
  })), _defineProperty(_ref5, '& .swiper-scrollbar-drag', {
    backgroundColor: theme.palette.primary.main
  }), _defineProperty(_ref5, '& * img', {
    borderRadius: '2px',
    display: 'flex',
    height: 'inherit',
    objectFit: 'contain',
    width: '100%'
  }), _defineProperty(_ref5, '& * video', {
    borderRadius: '2px',
    display: 'flex',
    height: 'inherit',
    objectFit: 'contain',
    width: '100%'
  }), _defineProperty(_ref5, '& .swiper-slide-thumb-active', {
    '& .slide-padding': {
      border: "2px solid ".concat(theme.palette.primary.main),
      borderRadius: '5px',
      height: '52px',
      overflow: 'hidden'
    }
  }), _defineProperty(_ref5, '& .slide-padding', {
    backgroundColor: 'transparent',
    alignItems: 'center',
    border: '1px solid #e7e7ea',
    borderRadius: '5px',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    overflow: 'hidden',
    width: 'inherit'
  }), _defineProperty(_ref5, '& .swiper-slide', {
    alignItems: 'center',
    display: 'flex',
    height: '42px',
    maxWidth: '85px'
  }), _ref5;
});
exports.StyledThumbs = StyledThumbs;
var StyledModalBody = (0, _styled.default)('div')(function (_ref6) {
  var theme = _ref6.theme;
  return {
    width: '100%',
    backgroundColor: theme.palette.background.default,
    height: '100vh',
    padding: '20px 35px'
  };
});
exports.StyledModalBody = StyledModalBody;
var StyledCloseIcon = (0, _styled.default)(_Close.default)({
  position: 'absolute',
  top: '14px',
  right: '10px',
  cursor: 'pointer',
  zIndex: 1000
});
exports.StyledCloseIcon = StyledCloseIcon;
var StyledZoomButton = (0, _styled.default)('button')({
  position: 'absolute',
  top: '10px',
  right: '50px',
  fontSize: '15px',
  cursor: 'pointer',
  border: '1px solid #0054A0',
  color: '#0054A0',
  zIndex: 1000,
  width: 113,
  padding: '8px 0',
  backgroundColor: '#fff',
  borderRadius: 4
});
exports.StyledZoomButton = StyledZoomButton;
var StyledPagination = (0, _styled.default)('div')(function (_ref7) {
  var _ref8;
  var theme = _ref7.theme;
  return _ref8 = {
    display: 'none',
    marginTop: '16px',
    height: '16px',
    alignItems: 'center',
    justifyContent: 'center'
  }, _defineProperty(_ref8, theme.breakpoints.down('md'), {
    display: 'flex'
  }), _defineProperty(_ref8, '& .slide-pagination-bullet', {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    appearance: 'none',
    border: 'none',
    display: 'inline-block',
    padding: '0',
    margin: '0 2px',
    cursor: 'pointer',
    backgroundColor: 'rgba(0, 83, 160, 0.12)',
    '&.arrow': {
      width: 0,
      height: 0,
      borderTop: '6px solid transparent',
      borderBottom: '6px solid transparent',
      borderLeft: '8px solid rgba(0, 83, 160, 0.12)',
      borderRadius: 0,
      background: 'none'
    }
  }), _defineProperty(_ref8, '& .slide-pagination-bullet-active', {
    backgroundColor: '#0053A0',
    width: '10px',
    height: '10px',
    '&.arrow': {
      borderLeftColor: 'rgb(0, 83, 160) !important'
    }
  }), _defineProperty(_ref8, '& .sr-only', {
    border: '0 !important',
    clip: 'rect(1px, 1px, 1px, 1px) !important',
    clipPath: 'inset(50%) !important',
    height: '1px !important',
    margin: '-1px !important',
    overflow: 'hidden !important',
    padding: '0 !important',
    position: 'absolute !important',
    width: '1px !important',
    whiteSpace: 'nowrap !important'
  }), _ref8;
});
exports.StyledPagination = StyledPagination;